import useSWR from 'swr';
import AxiosConfig from '../../../config/AxiosConfig';

const fetcher = async (url) =>
  await AxiosConfig.create('get', url).call().getResponseData();

function useOrderCancelReasons(userId) {
  const { data, _error, mutate } = useSWR(
    userId ? `/ordercancelreasons/` : null,
    (url) => fetcher(url),
    {
      refreshInterval: 0,
      revalidateOnFocus: true,
    }
  );

  return {
    orderCancelReasons: data,
    mutate: mutate,
  };
}

export default useOrderCancelReasons;
